"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headers = exports.createIssueMarkupsApi = void 0;
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
var _constants = require("../constants");
var _endpointHelpers = require("../util/endpointHelpers");
// there does exist a JS sdk for this by way of @plangrid/web-api-clients,
// but it is burdened by being connected to a lot of unnecessary plangrid logic and other services
// which are not necessary for our use case, and since this lib is a dependency we are trying to keep
// the number of dependencies that we rely on to a minimum.
// The API gives us types, but that's about it.
// It is probably worth switching at some point in the future if we find we need to use it more heavily.

const headers = exports.headers = {
  "Content-Type": "application/json"
};
const capiOrigin = (() => {
  const env = (0, _acsScWebPlatformApi.getEnv)();
  const region = (0, _acsScWebPlatformApi.getRegion)();
  switch (env) {
    case _acsScWebPlatformApi.ENVS.PRODUCTION:
      switch (region) {
        case _acsScWebPlatformApi.REGIONS.EMEA:
          return "https://io.plangrid.be";
        // APAC and AUS are the same region. Alloy team is currently using both APAC and AUS.
        // There is a transition time when both will be used, until the migration is done from APAC to AUS,
        // and then, APAC will be deleted and only AUS will be used.
        case _acsScWebPlatformApi.REGIONS.APAC:
        case _acsScWebPlatformApi.REGIONS.AUS:
          return "https://io.plangrid.com.au";
        default:
          return "https://io.plangrid.com";
      }
    case _acsScWebPlatformApi.ENVS.STAGING:
      switch (region) {
        // APAC and AUS are the same region. Alloy team is currently using both APAC and AUS.
        // There is a transition time when both will be used, until the migration is done from APAC to AUS,
        // and then, APAC will be deleted and only AUS will be used.
        case _acsScWebPlatformApi.REGIONS.APAC:
        case _acsScWebPlatformApi.REGIONS.AUS:
          return "https://io.aus-stg.planfront.net";
        default:
          return "https://plangrid-c-api-dispatcher-test.planfront.net";
      }
    case _acsScWebPlatformApi.ENVS.QA:
      return "https://plangrid-c-api-dispatcher-dev.planfront.net";
    default:
      throw new Error("Using capiUrl outside of supported envs");
  }
})();
const createIssueMarkupsApi = exports.createIssueMarkupsApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api,
    projectId
  } = _ref;
  return {
    delete(markupId) {
      // see https://plangridscribble-dev-rnd-salad.auto-internal.planfront.net/swagger/ui/#/annotations/delete_annotation
      // ...we don't care much about the result here (it's empty and the http code is 204: No Content)
      return api.delete("annotations2/".concat(markupId));
    },
    batchGet(issueUids, options) {
      // see https://plangridscribble-dev-rnd-salad.auto-internal.planfront.net/swagger/ui/#/annotations/search_annotations
      // for documentation on this API call.
      return api.request("annotations2_/search", _constants.HttpMethod.Post, {
        type: "issue",
        uids: issueUids,
        include_deleted: options.includeDeleted,
        deleted_after: options.deletedAfter
      }, {
        requestType: _constants.RequestType.Query
      }).then(response => {
        const sheetAssociation = {};
        // for each of the queried IDs, `sheetAssociation` will either be null,
        // or have a result. We start by populating everything as null.
        issueUids.forEach(issueUid => {
          sheetAssociation[issueUid] = null;
        });
        response.data.forEach(item => {
          // then we add the results to `sheetAssociation`...
          // `item.feature_uid` is the issueUid
          sheetAssociation[item.feature_uid] = {
            sheetId: item.surface_uid,
            markupId: item.uid,
            surfaceType: item.surface_type,
            documentVersionId: item.base_entity_uid,
            viewableGuid: item.viewable_guid
          };
        });
        return sheetAssociation;
      });
    },
    // create markup
    create(issueId, payload) {
      return api.create("annotations2_/update", {
        data: [{
          ...payload,
          feature_bound_type: "issue",
          feature_bound_link: "/projects/".concat(projectId, "/issue/").concat(issueId)
        }]
      }).then(_ref2 => {
        let {
          data: [markup]
        } = _ref2;
        return markup;
      });
    }
  };
}, {
  origin: capiOrigin,
  invalidateByQueryKeys: () => [["annotations2_"]]
});
//# sourceMappingURL=IssueMarkupsApi.js.map